import React from "react";
import { useField } from "formik";
import Select, { Props as ReactSelectProps } from "react-select";

// Define a type for your select options.
export interface OptionType {
  value: string;
  label: string;
  // Optionally include extra fields, e.g. for address lookups.
  address?: {
    line1: string;
    line2: string;
    town: string;
    postcode: string;
    country: string;
  };
}

export interface FormikSelectProps extends ReactSelectProps<OptionType, false> {
  name: string;
  options: OptionType[];
}

const FormikSelect: React.FC<FormikSelectProps> = ({ name, options, ...props }) => {
  const [field, meta, helpers] = useField(name);
  return (
    <div tabIndex={0} onBlur={() => helpers.setTouched(true)}>
      <Select<OptionType, false>
        {...props}
        name={name}
        options={options}
        value={options && field.value ? options.find((option) => option.value === field.value) : null}
        onChange={(option) => {
          helpers.setValue(option ? option.value : undefined);
          helpers.setTouched(true);
        }}
        onBlur={() => {
          helpers.setTouched(true);
        }}
      />
    </div>
  );
};

export default FormikSelect;